import React from 'react';
import { Instagram } from 'lucide-react';

// Preserve the supplied files; the viewport displays only the square logo artwork.
const channels: Record<string, { label: string; image: string; viewBox: string; width: number; height: number; background: string }> = {
  waha: {
    label: 'WhatsApp Business', image: '/images/channels/whatsapp-reference.png',
    viewBox: '43 30 426 426', width: 512, height: 512,
    background: 'linear-gradient(135deg, #00E65B, #00C936)',
  },
  official_whatsapp: {
    label: 'WhatsApp — API oficial Meta', image: '/images/channels/official-whatsapp-reference.png',
    viewBox: '120 90 500 500', width: 740, height: 740,
    background: '#FFFFFF',
  },
};

export default function ChannelBadge({ channel, variant = 'badge' }: { channel?: string | null; variant?: 'badge' | 'avatar' }) {
  const containerClass = variant === 'avatar'
    ? 'block h-full w-full overflow-hidden p-1.5'
    : 'absolute -bottom-0.5 -right-0.5 block h-[18px] w-[18px] lg:h-5 lg:w-5 overflow-hidden rounded-full p-0.5 shadow-sm';
  if (channel === 'instagram') return (
    <span role="img" aria-label="Canal: Instagram" title="Instagram" className={`${containerClass} text-white`} style={{ background: 'linear-gradient(45deg, #FCAF45, #DD2A7B, #8134AF)' }}>
      <Instagram className="h-full w-full" aria-hidden="true" />
    </span>
  );
  const presentation = channel ? channels[channel] : undefined;
  if (!presentation) return null;
  const { label, image, viewBox, width, height, background } = presentation;
  return (
    <span role="img" aria-label={`Canal: ${label}`} title={label} style={{ background }} className={containerClass}>
      <svg viewBox={viewBox} className="block h-full w-full overflow-hidden rounded-full" aria-hidden="true">
        <image href={image} width={width} height={height} />
      </svg>
    </span>
  );
}
